import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestModelosVeiculos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'modelosveiculos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteModelosVeiculo({ payload }) {
  try {
    const { idmodeloveiculo, params } = payload;

    yield call(api.delete, `modelosveiculos/${idmodeloveiculo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { modelosveiculo, params } = payload;

    yield call(api.post, 'modelosveiculos', modelosveiculo);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/modelosveiculos');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { idmodeloveiculo } = payload;

    const { data } = yield call(api.get, `modelosveiculos/${idmodeloveiculo}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { modelosveiculo, params } = payload;

    yield call(api.put, 'modelosveiculos', modelosveiculo);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/modelosveiculos');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'modelosveiculos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@modelosveiculo/MODELOSVEICULOS_IN_REQUEST',
    requestModelosVeiculos
  ),
  takeLatest('@modelosveiculo/DELETE_MODELOSVEICULO', deleteModelosVeiculo),
  takeLatest('@modelosveiculo/SUCCESS_REMOVE', requestModelosVeiculos),
  takeLatest('@modelosveiculo/STORE_MODELOSVEICULO', store),
  takeLatest('@modelosveiculo/FIND_MODELOSVEICULO', find),
  takeLatest('@modelosveiculo/UPDATE_MODELOSVEICULO', update),
  takeLatest('@modelosveiculo/RECORD_FILTERING', applyedFilters),
]);
